module.exports = __webpack_public_path__ + "img/bg-sh.b8aa021c.png";